<template>
	<information-card
		title="Configurar Procesos"
		sub-title="Instrucciones"
	>
		<div slot="content">
			<p class="textjustify">Selecciona la evaluación y configura tu proceso de acuerdo
				al tipo de evaluación que se requiere para tus empleados
				que seleccionaras.
			</p>
			<div class="content-rule tw-py-2">
				<br>
				<p style="text-align: center;">Paso 1:<span class="text-color">Seleccionar evaluación y configurar proceso.</span></p>
			</div>
			<br>
			<div class="content-table">
				<h2>Escala de Evaluación</h2>
				<h2 class="mb-3">Ejemplo</h2>
				<table>
					<tbody>
						<tr>
							<td><button :style="`background-color: ${$appColors.primary}`"></button></td>
							<td :style="`color: ${$appColors.primary}`" class="tw-py-1">Alto</td>
							<td>(2.5 - 3)</td>
						</tr>
						<tr>
							<td><button :style="`background-color: ${$appColors.accent}`"></button></td>
							<td :style="`color:${$appColors.accent}`" class="tw-py-1">Medio Alto</td>
							<td>(2.2 - 2.4)</td>
						</tr>
						<tr>
							<td><button :style="`background-color: ${$appColors.secondary}`"></button></td>
							<td :style="`color:${$appColors.secondary}`" class="tw-py-1">Medio</td>
							<td>(1.6 - 2.1)</td>
						</tr>
						<tr>
							<td><button :style="`background-color: ${$appColors.error}`"></button></td>
							<td :style="`color:${$appColors.error}`" class="tw-py-1">Bajo</td>
							<td>(0 - 1.5)</td>
						</tr>
					</tbody>
					
				</table>
			</div>
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';

export default {
	name: 'process-model-description',
	components: {
		InformationCard,
	},
};

</script>

<style lang="scss" scoped>
.textjustify {
	text-align: center;
	font-size: 12px;
}
.content-rule {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 1px solid map-get($colors, gray-slider);
	background-color: #F9F9F9;
	border-radius: 4px;
	font-size: 10px;
	height: 100%;
}
.text-color {
	color: #f09c2e;
	padding-left: 5px;
}
.table-info {
	border: #f09c2e 1px solid;
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.row-table-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	
}
.btn-model {
	background-color: #F9F9F9;
	width: 50px;
	height: 25px;
	border-radius: 8px;

}
.content-table {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	tr {
		margin: 10px 0;
	}
	h2, td {
		font-size: 13px;
		font-weight: bold;
		text-align: left;
		padding-left: 15px;
	}
	button {
		border-radius: 4px;
		border: none;
		width: 45px;
		height: 20px;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/process/process-model-description.vue